import { Ref } from 'vue';

export default function useTrackLayer(mapInstance: LooseObject, layerInfo: Ref<MapLayer<TrackLayerConfig>>) {
  if (!layerInfo.value || !layerInfo.value.config || !TMap.traffic?.TrackManager) return;

  const trackLayer = new TMap.traffic.TrackManager(mapInstance);

  const unwatch = watchEffect(() => {
    try {
      const trackList = layerInfo.value.config.data.map((track: TrackGeometry, index: number) => {
        const { id, type, path } = track;
        const pathList = path.map((point: PathPoint) => ({
          ...point,
          position: new TMap.LatLng(point.position.lat, point.position.lng),
        }));
        return {
          id: id ? id : `${index}`,
          type,
          path: pathList,
        };
      });

      trackLayer.set(trackList);
    } catch (error) {
      trackLayer.set([]);
    }
  });

  trackLayer.unmount = (): void => {
    trackLayer?.destroy();
    unwatch();
  };

  return trackLayer;
}
